import nodePath from '~/helpers/nodePath';

const space = /\s/g;

const pathToString = (element: HTMLElement) => {
  if (element.nodeType === Node.DOCUMENT_NODE) {
    return 'DOCUMENT';
  }

  return nodePath(element).map((node) => {
    const className = node.getAttribute('class') || '';

    return node.tagName.toLowerCase() +
      (node.id
        ? `#${node.id}`
        : '') +
      (node.dataset && node.dataset.testId
        ? `[testId='${node.dataset.testId}']`
        : '') +
      (className
        ? `.${className.replace(space, '.')}`
        : '')
      ;
  }).join(' ');
};

export default pathToString;
